import { render, staticRenderFns } from "./SurgAddBlock.vue?vue&type=template&id=54be58f3"
import script from "./SurgAddBlock.vue?vue&type=script&lang=js"
export * from "./SurgAddBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports